import { TaskStatusCode, taskStatusTextMap } from './model';

export function getTaskStatus(status: TaskStatusCode) {
  return taskStatusTextMap.get(status);
}
